import React from "react";

function HealthyIcon({className}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M22.559.705c-2.052 1.009-4.144 1.219-6.098 1.296-.619.024-1.231.033-1.837.041-3.37.048-6.855.097-9.71 2.953A9.88 9.88 0 002 12.029c0 2.327.794 4.532 2.252 6.305L.033 22.553l1.414 1.414 4.222-4.222a9.924 9.924 0 006.279 2.226 9.912 9.912 0 007.033-2.909C23.391 14.65 24 8.063 24 1.602V-.004l-1.441.709zm-4.991 16.944c-3.1 3.099-8.14 3.099-11.239 0-1.502-1.501-2.328-3.497-2.328-5.62s.826-4.119 2.328-5.62c2.281-2.282 5.082-2.321 8.324-2.367.622-.009 1.251-.018 1.887-.043 1.651-.064 3.538-.231 5.448-.894-.1 5.529-.848 10.971-4.42 14.543zm-5.067-9.797c-.575-.533-1.36-.852-2.25-.852-1.792 0-3.25 1.539-3.25 3.43 0 2.982 4.425 6.141 4.93 6.491l.57.396.57-.396c.505-.35 4.93-3.509 4.93-6.491 0-1.892-1.458-3.43-3.25-3.43-.89 0-1.675.318-2.25.852zm3.5 2.579c0 1.239-1.891 3.186-3.499 4.428-1.414-1.1-3.501-3.096-3.501-4.428 0-.789.561-1.43 1.25-1.43.622 0 1.25.374 1.25 1.209v.791h2v-.791c0-.835.628-1.209 1.25-1.209.689 0 1.25.642 1.25 1.43z"></path>
    </svg>
  );
}

export { HealthyIcon };
